import {Injectable} from '@angular/core';
import {ISessionState, UserRole} from '../interfaces/isession-state';
import {Store} from '../../core/types/store';
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {BrandModel} from "../interfaces";

@Injectable({
	providedIn: 'root',
})
export class SessionService extends Store<ISessionState|null> {

	constructor() {
		let sessionState = {} as ISessionState;
		const stateJson = localStorage.getItem('state');
		if (stateJson) {
			sessionState = JSON.parse(stateJson);
		}

		super(sessionState);
	}

	setState(nextState: ISessionState|null): void {
		localStorage.setItem('state', JSON.stringify(nextState));
		super.setState(nextState);
	}

	unsetState(): void {
		localStorage.removeItem('state');
		super.setState(null);
	}
}
